import { Component, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentService } from 'src/app/services/payment.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-confirmemail',
  templateUrl: './confirmemail.component.html',
  styleUrls: ['./confirmemail.component.css']
})
export class ConfirmemailComponent implements OnInit {  
  successMessage:string;
  errorMessage:string;
  tokenSet = false;
  paymentWindow: Window;

  constructor( private confirmationService : UseraccessserviceService, private moduleService: ModulemanagementService,
    private router :ActivatedRoute, private route: Router, private payments: PaymentService) { }

  ngOnInit(): void {
    let code = this.router.snapshot.queryParams.code;
    let postVerificationReturnUrl = this.router.snapshot.queryParams.goto;
      this.confirmationService.confirmAccount(code).subscribe(
        async (data : any) => {
          this.successMessage = data.message;
          if(data.token){
            this.confirmationService.setAuthenticatedUserToken(data.token);
            this.tokenSet = true;
            if (postVerificationReturnUrl){
              this.route.navigateByUrl(postVerificationReturnUrl + '&from=enrollnow');
            }
            else{
              this.route.navigate(["/user/schoolhome"]);
            }
          }
        },
        (error :HttpErrorResponse)=>{          
          if(error.status === 0){
            this.errorMessage =  "Unable to connect to server";
          }
          else if(error.status === 400){
            this.errorMessage = error.error.message;
          }
        }
      );
  }


}
